import React from 'react';
import { DateTime } from '@reynolds/datetime';
import { TimeOfDay, Transportation, rmTimeRec, ApptOps, rmTransEligible, VehicleRec, SpecData } from 'src/models';
import { strings } from 'src/localization';
import CalendarSelectAppt from './CalendarSelectAppt/CalendarSelectAppt';
import css from './CalendarSelect.module.scss';
import moment from 'moment';
import 'moment/min/locales.min';
import { IView } from '@framework-controls/core';
import classNames from 'classnames';
import { IAppointmentState } from 'src/store/states';

interface IProps {
    id: string;
    dateSelected: DateTime;
    timeOfDay: TimeOfDay;
    transportation: Transportation[];
    rmTimes: rmTimeRec[];
    advSelectedName: string;
    theme: string;
    apptOps: ApptOps[];
    locale: string;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    apptTimeChange: (time: string, transportation: Transportation) => void;
    apptHandler: (e: any) => void;
    rmTransEligible: rmTransEligible;
    mainPaneViewOrder: IView[];
    btnSelected: string;
    gmossVersion: string;
    appointment: IAppointmentState;
    specData?: SpecData;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
}
const CalendarSelectDisplay = (props: IProps) => {
    const { timeOfDay, dateSelected, advSelectedName } = props;

    let processingDate = dateSelected.toDate();
    let processingUTCDate = moment.utc(processingDate);
    processingUTCDate = processingUTCDate.locale(props.locale);

    processingDate = dateSelected.toDate();
    processingUTCDate = moment.utc(processingDate);
    processingUTCDate = processingUTCDate.locale(props.locale);
    const dateLabel2 = processingUTCDate.format('MMMM D');

    const hrStyles = classNames(
        css.hr,
        {
            [css.hrHonda]: props.theme === 'honda',
            [css.hrFord]: props.theme === 'ford',
            [css.hrIN]: props.theme === 'infiniti',
            [css.hrNissan]: props.theme === 'nissan',
            [css.hrMazda]: props.theme === 'mazda',
            [css.hrAcura]: props.theme === 'acura',
            [css.hrGenesis]: props.theme === 'genesis',
            [css.hrLexus]: props.theme === 'lexus',
        },
    );

    return (
        <>
            <div className={hrStyles}>
                {strings.HereAre} <strong>{timeOfDay.title}</strong> {strings.Times}&nbsp;
                <strong className={css.titlecase}>{dateLabel2}</strong>&nbsp;
                {strings.With} <strong>{advSelectedName}</strong>.
            </div>
            <CalendarSelectAppt
                selectedDate={dateSelected}
                setSelectedTime={props.apptTimeChange}
                timeOfDay={timeOfDay}
                transportation={props.transportation}
                rmTimes={props.rmTimes}
                theme={props.theme}
                apptOps={props.apptOps}
                locale={props.locale}
                rmTransEligible={props.rmTransEligible}
                mainPaneViewOrder={props.mainPaneViewOrder}
                btnSelected={props.btnSelected}
                vehicles={props.vehicles}
                selectedVehicle={props.selectedVehicle}
                gmossVersion={props.gmossVersion}
                appointment={props.appointment}
                sessionId={props.sessionId}
                lexusMCLaunched = {props.lexusMCLaunched}
                lexusTDMCLaunched = {props.lexusTDMCLaunched}
                toyotaMCLaunched = {props.toyotaMCLaunched}
                toyotaTDMCLaunched = {props.toyotaTDMCLaunched}
                specData={props.specData}
            />
        </>
    );
};

export default CalendarSelectDisplay;